export enum Status {
  NONE,
  EASE_IN,
  DISPLAY,
  EASE_OUT,
  COMPLETE
}

export interface TimedNotificationPropsInterface {
  content?: JSX.Element
  onComplete?(): void
  secsEaseIn?: number
  secsDisplay?: number
  secsEaseOut?: number
  children?: React.ReactNode
}

export interface TimedNotificationStateInterface {
  status: Status
}
